export type SortType = -1 | 0 | 1;

export const SortTypeUnknown: SortType = -1;
export const SortTypeAscending: SortType = 0;
export const SortTypeDescending: SortType = 1;

export interface FieldSort {
  field: string;
  order: SortType;
}
